import { render, staticRenderFns } from "./InsLatestNews.vue?vue&type=template&id=29caf551&scoped=true&"
import script from "./InsLatestNews.vue?vue&type=script&lang=ts&"
export * from "./InsLatestNews.vue?vue&type=script&lang=ts&"
import style0 from "./InsLatestNews.vue?vue&type=style&index=0&id=29caf551&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29caf551",
  null
  
)

export default component.exports